/* ==========================================================================
   Back-navigation recovery: scroll lock + stale cart contents.
   Loaded globally from layout/theme.liquid.

   NO AUTOMATIC RELOADS. READ THIS BEFORE ADDING ONE BACK.
   An earlier version reloaded the page when it still looked scroll-locked
   after a cleanup attempt, guarded by a sessionStorage flag. That caused the
   THEME EDITOR to refresh itself continuously:
     - the editor renders the storefront inside a sandboxed iframe where
       sessionStorage can throw, so the guard was never stored and every load
       was treated as the first, and
     - the editor applies its own scroll handling to that preview, so the
       "is it locked?" check was true on a perfectly healthy page.
   Net effect: detect -> reload -> detect -> reload, forever, on the LIVE site.

   The lesson: never let a heuristic trigger a navigation. Releasing the lock
   is safe and reversible; reloading is neither. This file now only ever
   RELEASES - if that does not work, the page is left alone rather than put
   into a loop.

   BACKGROUND (confirmed by reading the theme's own code)
     - theme-drawer.js has NO history handling: no pushState, no popstate. Back
       never closes the drawer, it navigates away. That is why on iPhone Back
       leaves the page entirely - correct behaviour, not a bug.
     - The sessionStorage restore in theme-drawer.liquid is guarded by
         if (!window.matchMedia('(min-width: 990px)').matches) return;
       so on a phone the drawer is never re-opened after a navigation.

   What remains is Chrome's back-forward cache on Android: the page is restored
   byte for byte, the <dialog> keeps [open] but loses modal/top-layer status
   (so buttons still work) while the lock applied by lockScroll() is still in
   force with nothing left to release it. Scrolling is the only thing broken.
   ========================================================================== */
(function () {
  // The theme editor drives its own preview. Never interfere with it.
  var IN_EDITOR = (window.Shopify && window.Shopify.designMode) ||
                  document.documentElement.classList.contains('shopify-design-mode');
  if (IN_EDITOR) return;

  function scrollIsLocked() {
    var b = getComputedStyle(document.body);
    var h = getComputedStyle(document.documentElement);
    if (b.position === 'fixed') return true;
    return b.overflow === 'hidden' || b.overflowY === 'hidden' ||
           h.overflow === 'hidden' || h.overflowY === 'hidden';
  }

  /* A drawer the visitor can SEE is a legitimate lock - leave it alone. */
  function drawerVisible() {
    var panels = document.querySelectorAll('.theme-drawer__dialog[open], dialog[open]');
    for (var i = 0; i < panels.length; i++) {
      var r = panels[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.right > 0 && r.left < window.innerWidth) return true;
    }
    return false;
  }

  function attemptRelease() {
    document.querySelectorAll('theme-drawer[open]').forEach(function (el) {
      if (typeof el.close === 'function') { try { el.close(); } catch (e) {} }
      el.removeAttribute('open');
    });
    document.querySelectorAll('dialog[open]').forEach(function (d) {
      try { d.close(); } catch (e) { d.removeAttribute('open'); }
    });
    [document.documentElement, document.body].forEach(function (n) {
      if (!n) return;
      ['overflow', 'overflowY', 'position', 'top', 'left', 'right', 'width', 'height', 'paddingRight']
        .forEach(function (p) { if (n.style && n.style[p]) n.style[p] = ''; });
    });
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.classList.remove('page-wrapper--drawer-open');
    try { sessionStorage.removeItem('theme-drawer-open'); } catch (e) {}
  }

  function unstick() {
    if (!scrollIsLocked() || drawerVisible()) return;
    attemptRelease();
  }

  /* Stale cart markup after a back-forward restore.
     Refreshes the DRAWER CONTENTS ONLY - no page reload. The restored page can
     carry the cart markup from before the item was added, which is why the
     drawer looked empty while the header count was right. */
  function refreshCartUi() {
    var url = (window.Theme && Theme.routes && Theme.routes.cart_url) ? Theme.routes.cart_url : '/cart';
    fetch(url + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Ask the theme to re-render its cart UI from the real cart.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        document.querySelectorAll('cart-icon').forEach(function (el) {
          if (typeof el.requestUpdate === 'function') { try { el.requestUpdate(); } catch (e) {} }
        });
      })
      .catch(function () { /* offline - leave it */ });
  }

  window.addEventListener('pageshow', function (e) {
    unstick();
    setTimeout(unstick, 120);
    if (e.persisted) setTimeout(refreshCartUi, 150);
  });

  // Safety net: free a stuck page the moment the visitor touches it.
  document.addEventListener('touchstart', function () {
    if (scrollIsLocked() && !drawerVisible()) attemptRelease();
  }, { passive: true, capture: true });

  /* ---------------- sticky add-to-cart visibility ------------------------ */
  function initSticky() {
    var bar = document.getElementById('GwbStickyAtc');
    var buyBlock = document.getElementById('GwbNativeBuy');
    if (!bar || !buyBlock) return;

    function apply() {
      bar.classList.toggle('is-on', buyBlock.getBoundingClientRect().bottom <= 0);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { apply(); ticking = false; });
    }

    if (!bar.dataset.gwbBound) {
      bar.dataset.gwbBound = '1';
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      window.addEventListener('orientationchange', onScroll, { passive: true });
      window.addEventListener('pageshow', apply);
    }
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSticky);
  } else {
    initSticky();
  }
  document.addEventListener('shopify:section:load', initSticky);
})();
